import { render, staticRenderFns } from "./StudentSubjectsCreate.vue?vue&type=template&id=0599ead7"
import script from "./StudentSubjectsCreate.vue?vue&type=script&lang=js"
export * from "./StudentSubjectsCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports